export default "__VITE_ASSET__DFTNzm9Z__"